<template>
  <div class="widget-chat ai-virtual-assistant">

    <div class="hello p-d-flex p-flex-column p-ai-center p-jc-center" v-if="messages.length==0">
      <img src="assets/irinox/assistant/frosty_hello.gif" class="p-mb-3 p-mt-3" :alt="'Frosty'" height="150"/>
      <div class="hello-title">{{ $t('bot.hello.title') }}</div>
      <div class="hello-subtitle">{{ $t('bot.hello.subtitle1') }}</div>
      <div class="hello-subtitle">{{ $t('bot.hello.subtitle2') }}</div>
    </div>

    <div class="messages" ref="messages" v-if="messages.length > 0">
      <ul>
        <li v-for="message in messages" :key="message.id" :ref="message.id"
          :class="[{ 'message-from': message.role === 'assistant' }, { 'message-own': message.role === 'user' }, { 'message-error': message.error}]">
          <div class="message-content" v-html="parseBotMessage(message.content)"></div>
        </li>
      </ul>
    </div>

    <div class="animation-bar p-grid p-nogutter p-px-3 p-ai-center" v-if="messages.length > 0">
      <div class="animation-wrapper p-col-fixed">
        <Transition name="frosty-switch" mode="out-in">
          <img
            :key="animation"
            :src="'assets/irinox/assistant/frosty_' + animation + '.gif'"
            alt="Frosty"
            height="80"
          />
        </Transition>
      </div>
      <div class="typing-container p-col"  :style="'visibility: ' + (typing ? 'visible' : 'hidden')">
        <div class="typing-text">{{ animationMessage }}</div>
      </div>
    </div>

    <div class="new-message">
      <div class="message-input">
        <input v-model="text" type="text" ref="userTextInput" :placeholder="$t('bot.message_ph')" class="p-inputtext" @keyup.enter="sendMessage" :disabled="typing" :aria-label="$t('bot.message_ph')"/>
      </div>
      <div class="message-send">
        <img src="assets/irinox/icons/bot_send_message.svg" @click="sendMessage"
          :style="'cursor: ' + (isTextValid ? 'pointer' : 'default')" :alt="$t('bot.send')" />
      </div>
    </div>
  </div>
</template>

<script>
import AiService from '../../service/AiService';
import { mapGetters } from 'vuex';
import { marked } from 'marked';

export default {

  data() {
    return {
      typing: false,
      text: null,
      animation: 'default',
      animationMessage: '',
      lastAnimationMessageNumber: 0,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      messages: 'ai/chatBotMessages',
    }),
    isTextValid: function () {
      return this.text != null && this.text.length > 1;
    }
  },
  created() {
    this.aiService = new AiService();
  },
  mounted() {
    this.scrollDown(1, 'instant');
    // if(this.messages.length==0) {
    //   setTimeout(function() {
    //     this.start();
    //   }.bind(this), 100);
    // }
  },
  methods: {
    parseBotMessage(text) {
      // return text.replace(/(https?:\/\/[^\s]+)/g, function(url) { return '<a href="' + url + '" target="_blank">' + url + '</a>'; })
      // return text;
      return marked.parse(text);
    },
    updateTyping(isTyping) {
      if(isTyping) {
        this.typing = true;
      } else {
        this.typing = false;
        setTimeout(function() {
          this.$refs["userTextInput"]?.focus()
        }.bind(this), 100);
      }
    },
    scrollDown(timeout, behavior) {
      setTimeout(function (behavior) {
        if(this.messages.length>0) {
          this.$refs[this.messages[this.messages.length - 1].id]?.scrollIntoView({ behavior: behavior, block: "end", inline: "nearest" })
        }
      }.bind(this, behavior ?? 'smooth'), timeout);
    },
    // start() {
    //   this.updateTyping(true);
    //   // this.aiService.botStart(this.personaltoken)
    //   this.aiService.botSendMessage(this.personaltoken, this.$t('bot.start'), null, true)
    //     .then((data) => {
    //       if(data.code=="200" && (data.body || data.response)) {
    //         this.botMessage(data.body ?? data.response);
    //       } else {
    //         console.error("ERROR " + JSON.stringify(data));
    //         this.errorMessage();
    //       }
    //     })
    //     .catch(error => {
    //       console.error("ERROR " + error);
    //       this.errorMessage();
    //     });
    // },
    sendMessage() {
      if(this.isTextValid) {
        let msg = this.text;
        this.text = null;

        const resetSession = !this.messages?.length>0;
        
        this.userMessage(msg);
        
        this.animation = 'search';
        this.updateTyping(true);

        this.startAnimationMessage();

        this.aiService.botSendMessage(this.personaltoken, msg, null, resetSession)
          .then((data) => {
            if(data.code=="200" && (data.body || data.response)) {
              this.botMessage(data.body ?? data.response);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.errorMessage();
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.errorMessage();
          });
      }
    },
    errorMessage() {
      this.$store.commit('ai/addChatBotMessage', {
        id: "msg_" + Math.random(),
        role: "assistant",
        content: this.$t('bot.error') ?? "Error",
        date: new Date(),
        error: true
      });
      this.scrollDown(300);
      this.updateTyping(false);
      this.animation = 'error';
      this.restoreAnimation(10000);
    },
    botMessage(text) {
      this.$store.commit('ai/addChatBotMessage', {
        id: "msg_" + Math.random(),
        role: "assistant",
        content: text,
        date: new Date()
      });
      this.scrollDown(300);
      this.updateTyping(false);
      this.animation = 'happy';
      this.restoreAnimation(8000);
    },
    userMessage(text) {
      this.$store.commit('ai/addChatBotMessage', {
        id: "msg_" + Math.random(),
        role: "user",
        content: text,
        date: new Date()
      });
      this.scrollDown(300);
      // setTimeout(function (id) {
          //   this.$refs[id].scrollIntoView({ behavior: "smooth" })
          // }.bind(this, id), 300);
    },
    restoreAnimation(count = 4000) {
      setTimeout(function() {
        if(this.animation === 'happy' || this.animation === 'error') {
          this.animation = 'default';
          this.waitingAnimation();
        }
      }.bind(this), count);
    },
    waitingAnimation(count = 10000) {
      setTimeout(function() {
        if(this.animation === 'default' || this.animation === 'waiting' || this.animation === 'waiting2') {
          if(this.animation === 'default') {
            this.animation = 'waiting';
          } else if(this.animation === 'waiting') {
            this.animation = 'waiting2';
          } else {
             this.animation = 'default';
          }
          this.waitingAnimation(count);
        }
      }.bind(this), count);
    },
    startAnimationMessage() {
      this.writeAnimationMessage(this.$t('bot.messages.start_'+this.getAnimationMessageNumber(5)));
      this.randomAnimationMessage();
    },
    randomAnimationMessage() {
      setTimeout(function() {
        if(this.typing) {
          this.writeAnimationMessage(this.$t('bot.messages.random_'+this.getAnimationMessageNumber(12)));
          this.randomAnimationMessage();
        } else {
          this.animationMessage = '';
        }
      }.bind(this), 7000);
    },
    writeAnimationMessage(message) {
      this.animationMessage = '';
      let index = 0;
      let interval = setInterval(function() {
        if(index < message.length) {
          this.animationMessage += message.charAt(index);
          index++;
        } else {
          clearInterval(interval);
        }
      }.bind(this), 30);
    },
    getAnimationMessageNumber(max) {
      let number = Math.floor(Math.random() * max) + 1;
      while(number == this.lastAnimationMessageNumber) {
        number = Math.floor(Math.random() * max) + 1;
      }
      this.lastAnimationMessageNumber = number;
      return number;
    }
  }

}
</script>
